import { useEffect, useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Col, Form, FormGroup, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { URL } from "../../api";
import contact from "../../assets/images/contact.png";
import Banner from "../../components/general/Banner";
import Celikler from "../../components/general/Celikler";
import { fetchPageGetSlug } from "../../redux/slices/pageGetSlugSlice";
import { fetchSendMail } from "../../redux/slices/sendMailSlice";
import { fetchSeoGet } from "../../redux/slices/seoGetSlice";

const Contact = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", message: "" });
  const [emailValid, setEmailValid] = useState(true);
  const [phoneValid, setPhoneValid] = useState(true);
  const [showKvkkModal, setShowKvkkModal] = useState(false);
  const [kvkkAccepted, setKvkkAccepted] = useState(false);
  const page = useSelector((state) => state.pageGetSlug.data);
  const seo = useSelector((state) => state.seoGet.data);
  const [loading, setLoading] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const lang = useSelector((state) => state.lang.lang);
  const dispatch = useDispatch();
  const COUNTRY_PREFIX = "+90 (";

  const getData = async () => {
    setLoading(true)
    const pageSlug = "iletisim";
    await dispatch(fetchPageGetSlug({ slug: pageSlug }));
    await dispatch(fetchSeoGet({ slug: pageSlug }));
    setLoading(false)
  }

  useEffect(() => { getData() }, [])

  const validateEmail = (value) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEmailValid(regex.test(value));
  };

  const formatPhone = (value) => {
    let digits = value.replace(/\D/g, "").slice(0, 10);
    let formatted = "";

    if (digits.length > 0) formatted += digits.substring(0, 3);
    if (digits.length > 3) formatted += " " + digits.substring(3, 6);
    if (digits.length > 6) formatted += " " + digits.substring(6, 8);
    if (digits.length > 8) formatted += " " + digits.substring(8, 10);

    return formatted.trim();
  };

  const validatePhone = (value) => {
    const onlyNumbers = /^\d{10}$/;
    setPhoneValid(onlyNumbers.test(value.replace(/\D/g, "")));
  };

  const isFormValid = () => {
    return (
      formData.name.trim() !== "" &&
      formData.email.trim() !== "" &&
      formData.phone.trim() !== "" &&
      formData.message.trim() !== "" &&
      emailValid &&
      kvkkAccepted
    );
  };

  const handleKvkkAccept = () => {
    setKvkkAccepted(true);
    setShowKvkkModal(false);
  };

  const handleKvkkDecline = () => {
    setKvkkAccepted(false);
    setShowKvkkModal(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid()) {
      toast.error(t("form_required") || "Lütfen tüm alanları eksiksiz doldurun.", {
        position: "top-center",
        autoClose: 3000,
        theme: "colored",
      });
      return;
    }

    let token = "";
    if (executeRecaptcha) {
      token = await executeRecaptcha("contact_form");
      console.log("Captcha Token: ", token);
    } else {
      toast.error("reCAPTCHA doğrulanamadı.", {
        position: "top-center",
        autoClose: 3000,
        theme: "colored",
      });
      return;
    }

    if (token !== null && token !== undefined && token !== "") {
      var send = await dispatch(fetchSendMail({ name: formData.name, mail: formData.email, subject: "Çelikler Enerji İletişim Formu", phone: formData.phone, message: formData.message }));
      if (send.payload?.statusCode === 200) {
        setFormData({ name: "", email: "", phone: "", message: "" });
        setEmail("");
        setPhone("");
        toast.success(t("mail_success"), {
          position: "top-center",
          autoClose: 3000,
          theme: "colored",
        });
      } else {
        toast.error(t("mail_error"), {
          position: "top-center",
          autoClose: 3000,
          theme: "colored",
        });
      }
    } else {
      toast.error(t("mail_error"), {
        position: "top-center",
        autoClose: 3000,
        theme: "colored",
      });
    }
  };

  const LinkSchema = (text) => {
    if (text?.search("@") !== -1) {
      return "mailto:" + text;
    }
    if (text?.search("/") !== -1 || text.search("No:") !== -1 || text.search("no:") !== -1) {
      return "https://www.google.com/maps/place/" + text;
    }
    if (text?.search("Tel:") !== -1 || text?.search("tel:") !== -1 || text?.search("Fax:") !== -1 || text?.search("phone:") !== -1 || text?.search("Phone:") !== -1) {
      text = text?.replace("Tel:", "");
      text = text?.replace("tel:", "");
      text = text?.replace(" ", "");
      text = text?.replace("+", "");
      text = text?.replace("-", "");
      text = text?.replace("(", "");
      text = text?.replace(")", "");
      text = text?.replace("Phone:", "");
      text = text?.replace("phone:", "");
      text = text?.replace("Fax:", "");
      return "tel:" + text;
    }
  }

  const IsTargetBlank = (text) => {
    if (text?.search("/") !== -1 || text.search("No:") !== -1 || text.search("no:") !== -1) {
      return true;
    }
  }

  return (
    !loading ? <Celikler>
      {seo && seo.title && seo.description && (
        <Helmet>
          <title>{seo.title?.[lang] || "Çelikler Enerji"}</title>
          <meta name="description" content={seo.description?.[lang] || ""} />
          <meta name="keywords" content={seo.keywords?.[lang] || ""} />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href={window.location.href} />
        </Helmet>
      )}
      <Banner title={page?.title[lang]} />
      <div className="about-page">
        <div className="textJustifyCenter">
          <div className="contact-title f24 d-flex align-items-center justify-content-center mt-5">
            <span className="color10 fw500 f32 mt-3">{page?.showcases[0]?.title[lang]}</span>
          </div>
          <div className="mt-5">
            <Row>
              {
                (page?.showcases[0]?.modules ? [...page?.showcases[0]?.modules] : [])
                  .sort((a, b) => a.sort ? a.sort - b.sort : a.id - b.id)
                  .map((item, index) => {
                    return (
                      <Col xs={12} sm={12} md={4} lg={4} xl={4} key={index} className="text-center mb-3">
                        <img src={`${URL}${item?.files[0]}`} alt={item?.title[lang]} className="img-fluid mb-3" loading="lazy" />
                        <span className="blueText f20 d-block">
                          <strong>{item?.title[lang]}</strong>
                        </span>
                        <span style={{ display: "block", color: "rgba(14, 18, 27, 1)", fontSize: "16px", }}>
                          <Link
                            target={IsTargetBlank(item?.description?.[lang]) ? "_blank" : undefined}
                            className={typeof item?.description?.[lang] === "string" ? "text-dark" : undefined}
                            to={LinkSchema(item?.description?.[lang]) || "#"}
                          >
                            {item?.description?.[lang]}
                          </Link>
                        </span>
                        {item?.specialField1?.[lang] ?
                          <span style={{ display: "block", color: "rgba(14, 18, 27, 1)", fontSize: "16px", }}>
                            <Link
                              className={typeof item?.specialField1?.[lang] === "string" ? "text-dark" : undefined}
                              to={LinkSchema(item?.specialField1?.[lang]) || "#"}
                            >
                              {item?.specialField1?.[lang]}
                            </Link>
                          </span>
                          : null}
                      </Col>
                    )
                  })
              }
            </Row>

            <Row className="mx-md-4 my-5">
              <Col xs={12} className="d-block d-lg-none text-center mb-4">
                <img
                  src={contact}
                  alt="contact"
                  className="img-fluid "
                  style={{ objectFit: "contain", maxHeight: "300px" }}
                />
              </Col>

              <Col lg={6}>
                <div className="f32 fw500">
                  <span>{page?.showcases[1]?.modules[0]?.title[lang]}</span>
                </div>
                <Form className="mt-5" onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="fullName" className="form-label f16 fw500">
                      {t("full_name")}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      id="fullName"
                      placeholder={t("name_place_holder")}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="email" className="form-label f16 fw500">
                      {t("mail")}
                    </label>
                    <input
                      type="email"
                      className={`form-control ${!emailValid ? "is-invalid" : ""
                        }`}
                      id="email"
                      value={email}
                      onChange={(e) => { setEmail(e.target.value); setFormData({ ...formData, email: e.target.value }) }}
                      onBlur={(e) => validateEmail(e.target.value)}
                      placeholder={t("mail_place_holder")}
                    />
                  </div>

                  <FormGroup className="mb-3">
                    <label htmlFor="phone" className="form-label f16 fw500">
                      {t("phone_number")}
                    </label>
                    <input
                      type="tel"
                      className={`form-control ${!phoneValid ? "is-invalid" : ""}`}
                      id="phone"
                      maxLength={13}
                      value={phone}
                      onChange={e => {
                        const formatted = formatPhone(e.target.value);
                        setPhone(formatted);
                        setFormData({ ...formData, phone: formatted.replace(/\D/g, "") });
                        validatePhone(formatted);
                      }}
                      placeholder="5__ ___ __ __"
                      autoComplete="tel"
                    />
                  </FormGroup>

                  <div className="mb-3">
                    <label htmlFor="message" className="form-label">
                      {t("message")}
                    </label>
                    <textarea
                      className="form-control"
                      id="message"
                      rows="5"
                      onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                      placeholder={t("message_place_holder")}
                    ></textarea>
                  </div>

                  <label>
                    <div className="mb-3 d-flex align-items-center">
                      <input
                        type="checkbox"
                        name="kvkk"
                        checked={kvkkAccepted}
                        onChange={() => setKvkkAccepted(!kvkkAccepted)}
                      />

                      <a
                        href="#"
                        className="ml-3 text-decoration-none list-styled-none color4 f15 fw500"
                        onClick={(e) => { e.preventDefault(); setShowKvkkModal(true); }}
                      >
                        {t("kvkk")}
                      </a>
                    </div>
                  </label>

                  <button
                    type="submit"
                    className="btn btn-primary w-100 sssBtn"
                    disabled={!isFormValid()}
                  >
                    {t("send")}
                  </button>
                </Form>
              </Col>
              <Col lg={6} className="d-none d-lg-block p-3 mb-3">
                <img src={`${URL}${page?.showcases[1]?.files[0]}`} alt="contact" className="img-fluid" style={{ objectFit: "contain", maxHeight: "100%" }} loading="lazy" />
              </Col>
            </Row>
          </div>
        </div>
      </div>

      <Modal isOpen={showKvkkModal} toggle={() => setShowKvkkModal(false)} size="lg">
        <ModalHeader toggle={() => setShowKvkkModal(false)}>{t("kvkk")}</ModalHeader>
        <ModalBody>
          <div style={{ height: "70vh" }}>
            <iframe
              src={`${URL}${page?.showcases[1]?.modules[0]?.files[0]}`}
              title="KVKK Document"
              width="100%"
              height="100%"
              style={{ border: "none" }}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleKvkkDecline}>{t("decline")}</Button>
          <Button color="primary" onClick={handleKvkkAccept}>{t("accept")}</Button>
        </ModalFooter>
      </Modal>
    </Celikler > : <div className="modern-spinner-wrapper">
      <div className="modern-spinner"></div>
    </div>
  );
};

export default Contact;
